import React, { Component } from "react";
import "./FoodDeliveryPage.css";
import { AuthProvider } from "../DeliveryPage/pages/AuthContext";
import {
  BrowserRouter,
  Link,
  Outlet,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import HomeDelivery from "./HomeDelivery";
import ProductDelivery from "./ProductDelivery";
import {
  Badge,
  BottomNavigation,
  BottomNavigationAction,
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogTitle,
  Paper,
  Typography,
  Fab,
  IconButton,
  TextField,
  Avatar,
} from "@mui/material";
import {
  Home as HomeIcon,
  Search as SearchIcon,
  Person as PersonIcon,
  ShoppingCart as ShoppingCartIcon,
  Chat as ChatIcon,
  Close as CloseIcon,
  Send as SendIcon,
} from "@mui/icons-material";

import { CartContext } from "../comp/CartContext";
import Sacola from "./Sacola";
import AddressPage from "./AddressPage";
import Busca from "./Busca";
import Sobre from "./Sobre";
import Checkout from "./Checkout";
import Registrar from "./Registrar";
import NewAddress from "./AddressPage/NewAddress";
import { ToastContainer } from "react-toastify";
import DetalhesPedido from "./DetalhesPedido";
import SeusPedidos from "./SeusPedidos";

// COMPONENTE WRAPPER PARA OCULTAR O CHAT EM ROTAS ESPECÍFICAS
const ChatWidgetWithLocation = ({ renderChat }) => {
  const location = useLocation();

  // Liste aqui as rotas exatas onde você NÃO quer que o balão de chat apareça
  const hiddenRoutes = [
    "/sacola",
    "/checkout",
    "/address",
    "/address/new",
    "/pedidos"
  ];

  // Regra para rotas exatas
  if (hiddenRoutes.includes(location.pathname)) {
    return null;
  }

  // Regra para rotas dinâmicas (ex: /produto/123-abc)
  if (location.pathname.startsWith("/produto/")) {
    return null;
  }

  return renderChat();
};

class FoodDeliveryPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: {},
      cart: [],
      bottomNavValue: 0,
      isLoading: true,
      openDialogLogin: false,

      // ESTADO PARA ARMAZENAR AS ATUALIZAÇÕES DO SSE
      lastOrderUpdate: null,

      // ESTADOS DO CHAT DA LOJA
      chatOpen: false,
      chatInput: "",
      unreadCount: 1,
      isStoreTyping: false,
      chatMessages: [
        {
          id: 1,
          sender: "store",
          text: "Olá! Seja bem-vindo(a). Como posso te ajudar hoje?",
          time: new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }),
        },
      ],
    };

    this.eventSource = null;
    this.chatMessagesEndRef = React.createRef();
  }

  componentDidMount() {
    this.carregarDadosLoja();
    this.initCustomerSSE();
  }

  componentWillUnmount() {
    this.closeSSE();
  }

  componentDidUpdate(prevProps, prevState) {
    // Rola para o fim das mensagens sempre que uma nova mensagem for adicionada ou o chat for aberto
    if (
      (prevState.chatOpen !== this.state.chatOpen && this.state.chatOpen) ||
      prevState.chatMessages.length !== this.state.chatMessages.length ||
      prevState.isStoreTyping !== this.state.isStoreTyping
    ) {
      this.scrollToBottom();
    }
  }

  scrollToBottom = () => {
    if (this.chatMessagesEndRef.current) {
      this.chatMessagesEndRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  carregarDadosLoja = () => {
    fetch("/api/store/data", {
      method: "GET",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
    }).then((response) => {
      if (response.status === 200) {
        response.json().then((data) => {
          this.setState({ data, cart: data.cart || [], isLoading: false });
        });
      }
    });
  };

  initCustomerSSE = () => {
    const sseUrl = "/api/customer/stream";

    this.eventSource = new EventSource(sseUrl, {
      withCredentials: true,
    });

    this.eventSource.onopen = () => {
      console.log("Conectado ao SSE de atualização de pedidos do Comprador");
    };

    this.eventSource.onmessage = (event) => {
      try {
        const data = JSON.parse(event.data);
        this.handleOrderUpdate(data);
      } catch (err) {
        console.error("Erro ao ler evento SSE do comprador:", err);
      }
    };

    this.eventSource.addEventListener("order_status", (event) => {
      try {
        const data = JSON.parse(event.data);
        this.handleOrderUpdate(data);
      } catch (err) {
        console.error("Erro no evento order_status SSE:", err);
      }
    });

    this.eventSource.onerror = () => {
      console.warn("Reconectando ao SSE do Comprador em 5s...");
      this.eventSource.close();
      setTimeout(() => {
        this.initCustomerSSE();
      }, 5000);
    };
  };

  handleOrderUpdate = (data) => {
    console.log("Atualização de pedido recebida via SSE:", data);
    this.setState({ lastOrderUpdate: data });
  };

  closeSSE = () => {
    if (this.eventSource) {
      this.eventSource.close();
      this.eventSource = null;
    }
  };

  adicionarAoCarrinho = (novoProduto) => {
    this.setState((prevState) => ({
      cart: [...prevState.cart, novoProduto],
    }));
  };

  DialogLogin = () => {
    this.setState({ openDialogLogin: true });
  };

  limparCarrinho = () => {
    this.setState({ cart: [] });
  };

  removerDoCarrinho = (uuid) => {
    this.setState((prevState) => ({
      cart: prevState.cart.filter((produto) => produto.uuid !== uuid),
    }));
  };

  // --- FUNÇÕES DE GERENCIAMENTO DO CHAT ---
  toggleChat = () => {
    this.setState((prevState) => ({
      chatOpen: !prevState.chatOpen,
      unreadCount: prevState.chatOpen ? prevState.unreadCount : 0,
    }));
  };

  handleSendMessage = (e) => {
    if (e) e.preventDefault();

    const texto = this.state.chatInput.trim();
    if (!texto) return;

    const novaMensagemCliente = {
      id: Date.now(),
      sender: "user",
      text: texto,
      time: new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }),
    };

    this.setState((prevState) => ({
      chatMessages: [...prevState.chatMessages, novaMensagemCliente],
      chatInput: "",
      isStoreTyping: true,
    }));

    // Simula resposta automática da loja após 1.5 segundos
    setTimeout(() => {
      const respostasExemplo = [
        "Obrigado pelo contato! Em breve nosso atendente vai responder sua mensagem.",
        "Anotado! Se for sobre um pedido em andamento, você também pode acompanhar na aba 'Pedidos'.",
        "Estamos preparando os pedidos do momento! Já te respondemos em instantes.",
      ];
      const respostaSorteada =
        respostasExemplo[Math.floor(Math.random() * respostasExemplo.length)];

      const novaMensagemLoja = {
        id: Date.now() + 1,
        sender: "store",
        text: respostaSorteada,
        time: new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }),
      };

      this.setState((prevState) => ({
        chatMessages: [...prevState.chatMessages, novaMensagemLoja],
        isStoreTyping: false,
        unreadCount: !prevState.chatOpen ? prevState.unreadCount + 1 : 0,
      }));
    }, 1500);
  };

  renderChatWidget() {
    const { chatOpen, chatMessages, chatInput, unreadCount, isStoreTyping, data } =
      this.state;
    const themeColor = data.color || "#1976d2";

    // Posição ajustada dinamicamente caso o carrinho flutuante esteja visível na barra inferior
    const bottomOffset = this.state.cart.length > 0 ? "115px" : "70px";

    return (
      <>
        {/* BOTÃO FLUTUANTE DE CHAT (FAB) */}
        {!chatOpen && (
          <Fab
            color="primary"
            onClick={this.toggleChat}
            sx={{
              position: "fixed",
              bottom: bottomOffset,
              right: 16,
              zIndex: 1300,
              backgroundColor: themeColor,
              "&:hover": { backgroundColor: themeColor, filter: "brightness(0.9)" },
              transition: "bottom 0.3s ease",
            }}
          >
            <Badge badgeContent={unreadCount} color="error">
              <ChatIcon />
            </Badge>
          </Fab>
        )}

        {/* JANELA DO CHAT */}
        {chatOpen && (
          <Paper
            elevation={8}
            sx={{
              position: "fixed",
              bottom: { xs: 0, sm: 80 },
              right: { xs: 0, sm: 16 },
              width: { xs: "100%", sm: 360 },
              height: { xs: "100%", sm: 480 },
              maxHeight: { xs: "100vh", sm: "80vh" },
              zIndex: 1400,
              display: "flex",
              flexDirection: "column",
              borderRadius: { xs: 0, sm: 3 },
              overflow: "hidden",
            }}
          >
            {/* CABEÇALHO DO CHAT */}
            <Box
              sx={{
                backgroundColor: themeColor,
                color: "white",
                p: 2,
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                boxShadow: 1,
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                <Avatar
                  src={data.logo}
                  alt={data.name || "Loja"}
                  sx={{ width: 36, height: 36, bgcolor: "white", color: themeColor }}
                >
                  {(data.name || "L").charAt(0).toUpperCase()}
                </Avatar>
                <Box>
                  <Typography variant="subtitle1" sx={{ fontWeight: "bold", lineHeight: 1.2 }}>
                    {data.name || "Atendimento ao Cliente"}
                  </Typography>
                  <Typography variant="caption" sx={{ opacity: 0.9 }}>
                    {isStoreTyping ? "digitando..." : "Online"}
                  </Typography>
                </Box>
              </Box>

              <IconButton onClick={this.toggleChat} sx={{ color: "white" }}>
                <CloseIcon />
              </IconButton>
            </Box>

            {/* CORPO DE MENSAGENS */}
            <Box
              sx={{
                flex: 1,
                p: 2,
                overflowY: "auto",
                backgroundColor: "#f5f5f5",
                display: "flex",
                flexDirection: "column",
                gap: 1.5,
              }}
            >
              {chatMessages.map((msg) => {
                const isUser = msg.sender === "user";
                return (
                  <Box
                    key={msg.id}
                    sx={{
                      alignSelf: isUser ? "flex-end" : "flex-start",
                      maxWidth: "80%",
                    }}
                  >
                    <Paper
                      elevation={1}
                      sx={{
                        p: 1.5,
                        backgroundColor: isUser ? themeColor : "#ffffff",
                        color: isUser ? "#ffffff" : "#333333",
                        borderRadius: isUser
                          ? "16px 16px 2px 16px"
                          : "16px 16px 16px 2px",
                      }}
                    >
                      <Typography variant="body2" sx={{ wordBreak: "break-word" }}>
                        {msg.text}
                      </Typography>
                      <Typography
                        variant="caption"
                        sx={{
                          display: "block",
                          textAlign: "right",
                          mt: 0.5,
                          fontSize: "0.68rem",
                          opacity: 0.75,
                        }}
                      >
                        {msg.time}
                      </Typography>
                    </Paper>
                  </Box>
                );
              })}

              {isStoreTyping && (
                <Box sx={{ alignSelf: "flex-start" }}>
                  <Paper
                    elevation={1}
                    sx={{
                      p: 1.5,
                      backgroundColor: "#ffffff",
                      borderRadius: "16px 16px 16px 2px",
                    }}
                  >
                    <Typography variant="caption" color="textSecondary">
                      A loja está digitando...
                    </Typography>
                  </Paper>
                </Box>
              )}
              <div ref={this.chatMessagesEndRef} />
            </Box>

            {/* CAMPO DE ENTRADA / ENVIO */}
            <Box
              component="form"
              onSubmit={this.handleSendMessage}
              sx={{
                p: 1.5,
                backgroundColor: "white",
                borderTop: "1px solid #e0e0e0",
                display: "flex",
                alignItems: "center",
                gap: 1,
              }}
            >
              <TextField
                fullWidth
                size="small"
                placeholder="Digite sua mensagem..."
                variant="outlined"
                value={chatInput}
                onChange={(e) => this.setState({ chatInput: e.target.value })}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "20px",
                  },
                }}
              />
              <IconButton
                type="submit"
                color="primary"
                disabled={!chatInput.trim()}
                sx={{
                  backgroundColor: themeColor,
                  color: "white",
                  "&:hover": { backgroundColor: themeColor },
                  "&.Mui-disabled": { backgroundColor: "#e0e0e0", color: "#a0a0a0" },
                }}
              >
                <SendIcon fontSize="small" />
              </IconButton>
            </Box>
          </Paper>
        )}
      </>
    );
  }

  renderBottomNav() {
    var soma = this.state.cart.reduce((total, item) => {
      return total + item.preco_unitario_momento * item.quantidade;
    }, 0);

    return (
      <Paper
        sx={{ position: "fixed", bottom: 0, left: 0, right: 0, zIndex: 1200 }}
        elevation={3}
      >
        {this.state.cart.length > 0 && (
          <Box
            component={Link}
            to="/sacola"
            sx={{
              backgroundColor: this.state.data.color || "#1976d2",
              color: "white",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "12px 20px",
              textDecoration: "none",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Badge
                badgeContent={this.state.cart.length}
                color="default"
                sx={{
                  "& .MuiBadge-badge": {
                    backgroundColor: "white",
                    color: this.state.data.color || "#1976d2",
                  },
                }}
              >
                <ShoppingCartIcon />
              </Badge>
            </Box>

            <Typography sx={{ fontWeight: "bold" }}>Ver sacola</Typography>

            <Typography sx={{ fontWeight: "bold" }}>
              {soma.toLocaleString("pt-BR", {
                style: "currency",
                currency: "BRL",
              })}
            </Typography>
          </Box>
        )}
        <BottomNavigation
          showLabels
          value={this.state.bottomNavValue}
          onChange={(event, newValue) =>
            this.setState({ bottomNavValue: newValue })
          }
          sx={{
            "& .Mui-selected, & .Mui-selected svg": {
              color: this.state.data.color || "#1976d2 !important",
            },
          }}
        >
          <BottomNavigationAction
            component={Link}
            to="/"
            label="Início"
            icon={<HomeIcon />}
          />

          <BottomNavigationAction
            component={Link}
            to="/buscar"
            label="Buscar"
            icon={<SearchIcon />}
          />

          <BottomNavigationAction
            component={Link}
            to="/pedidos"
            label="Pedidos"
            icon={<ShoppingCartIcon />}
          />

          <BottomNavigationAction
            component={Link}
            to="/conta"
            label="Perfil"
            icon={<PersonIcon />}
          />
        </BottomNavigation>
      </Paper>
    );
  }

  MainLayout = () => (
    <>
      <Outlet />
      {this.renderBottomNav()}
    </>
  );

  AdicionarEndereco = (address) => {
    this.setState({ Address: address });
  };

  render() {
    const contextValue = {
      data: this.state.data,
      carrinho: this.state.cart,
      adicionarAoCarrinho: this.adicionarAoCarrinho,
      limparCarrinho: this.limparCarrinho,
      removerDoCarrinho: this.removerDoCarrinho,
      AdicionarEndereco: this.AdicionarEndereco,
      Address: this.state.Address,
      DialogLogin: this.DialogLogin,
      lastOrderUpdate: this.state.lastOrderUpdate,

      // Expõe ações e dados do chat no Context
      toggleChat: this.toggleChat,
      chatOpen: this.state.chatOpen,
    };

    if (this.state.isLoading)
      return (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
          }}
        >
          <CircularProgress />
        </Box>
      );

    return (
      <>
        <AuthProvider>
          <CartContext.Provider value={contextValue}>
            <BrowserRouter>
              <Routes>
                <Route element={<this.MainLayout />}>
                  <Route exact path="/" element={<HomeDelivery />} />
                  <Route exact path="/pedidos" element={<SeusPedidos />} />
                </Route>
                <Route exact path="/sobre" element={<Sobre />} />
                <Route exact path="/sacola" element={<Sacola />} />
                <Route exact path="/buscar" element={<Busca />} />
                <Route exact path="/checkout" element={<Checkout />} />

                <Route exact path="/pedidos/:id" element={<DetalhesPedido />} />
                <Route exact path="/conta" element={<>Meus dados</>} />
                <Route exact path="/registrar" element={<Registrar />} />
                <Route
                  exact
                  path="/produto/:uuid"
                  element={<ProductDelivery />}
                />
                <Route exact path="/address" element={<AddressPage />} />
                <Route exact path="/address/new" element={<NewAddress />} />
              </Routes>

              {/* RENDERIZAÇÃO DO WIDGET DE CHAT COM CONTROLE DE ROTAS */}
              <ChatWidgetWithLocation
                renderChat={() => this.renderChatWidget()}
              />
            </BrowserRouter>
            <Dialog
              open={this.state.openDialogLogin}
              onClose={() => this.setState({ openDialogLogin: false })}
              fullWidth
              maxWidth="xs"
            >
              <DialogTitle sx={{ fontWeight: "bold", fontSize: "1.1rem" }}>
                Para continuar, efetue o login
              </DialogTitle>
              <DialogActions>
                <Button
                  onClick={() => {
                    this.setState({ openDialogLogin: false });
                  }}
                >
                  Cancelar
                </Button>
                <Button
                  onClick={() => {
                    window.location.href =
                      "https://fazpedido.app/auth/login/" +
                      window.location.host.split(".")[0];
                  }}
                >
                  Login
                </Button>
              </DialogActions>
            </Dialog>
          </CartContext.Provider>
        </AuthProvider>
        <ToastContainer />
      </>
    );
  }
}

export default FoodDeliveryPage;